import React from 'react';

const Help = () => {
    return (
        <div className="container-fluid px-3 py-4">
            <div className="row">
                <div className="col-12">
                    <div className="card">
                        <div className="card-header">
                            <h4 className="mb-0">
                                <i className="fas fa-book me-2"></i>
                                User Manual - Asset Management System
                            </h4>
                        </div>
                        <div className="card-body">
                            {/* Getting Started */}
                            <section className="mb-5">
                                <h5 className="text-primary mb-3">
                                    <i className="fas fa-play-circle me-2"></i>
                                    Getting Started
                                </h5>
                                <p>Follow these steps to set up your asset management system:</p>
                                <div className="row g-3">
                                    <div className="col-sm-6 col-lg-3">
                                        <div className="step-card">
                                            <div className="step-badge">1</div>
                                            <h6>Create Departments</h6>
                                            <p className="small">Set up organizational departments</p>
                                        </div>
                                    </div>
                                    <div className="col-sm-6 col-lg-3">
                                        <div className="step-card">
                                            <div className="step-badge">2</div>
                                            <h6>Add Asset Types</h6>
                                            <p className="small">Define categories like Laptop, Mouse</p>
                                        </div>
                                    </div>
                                    <div className="col-sm-6 col-lg-3">
                                        <div className="step-card">
                                            <div className="step-badge">3</div>
                                            <h6>Register Employees</h6>
                                            <p className="small">Add staff with department info</p>
                                        </div>
                                    </div>
                                    <div className="col-sm-6 col-lg-3">
                                        <div className="step-card">
                                            <div className="step-badge">4</div>
                                            <h6>Add Assets</h6>
                                            <p className="small">Register individual items</p>
                                        </div>
                                    </div>
                                </div>
                            </section>

                            {/* Detailed Instructions */}
                            <section className="mb-5">
                                <h5 className="text-primary mb-3">
                                    <i className="fas fa-list-ol me-2"></i>
                                    Step-by-Step Instructions
                                </h5>
                                
                                <div className="accordion" id="helpAccordion">
                                    {/* Departments */}
                                    <div className="accordion-item">
                                        <h2 className="accordion-header">
                                            <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#departments">
                                                <i className="fas fa-building me-2"></i>
                                                Managing Departments
                                            </button>
                                        </h2>
                                        <div id="departments" className="accordion-collapse collapse show" data-bs-parent="#helpAccordion">
                                            <div className="accordion-body">
                                                <h6>Creating Departments:</h6>
                                                <ol>
                                                    <li>Navigate to <strong>Master Data → Departments</strong></li>
                                                    <li>Click <span className="badge bg-primary">Add Department</span></li>
                                                    <li>Enter department name (e.g., "IT", "HR", "Finance")</li>
                                                    <li>Add description if needed</li>
                                                    <li>Click <strong>Save</strong></li>
                                                </ol>
                                                <div className="alert alert-info small">
                                                    <strong>Note:</strong> Departments are required before adding employees.
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Asset Types */}
                                    <div className="accordion-item">
                                        <h2 className="accordion-header">
                                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#assetTypes">
                                                <i className="fas fa-tags me-2"></i>
                                                Managing Asset Types
                                            </button>
                                        </h2>
                                        <div id="assetTypes" className="accordion-collapse collapse" data-bs-parent="#helpAccordion">
                                            <div className="accordion-body">
                                                <h6>Creating Asset Types:</h6>
                                                <ol>
                                                    <li>Go to <strong>Master Data → Asset Types</strong></li>
                                                    <li>Click <span className="badge bg-primary">Add Asset Type</span></li>
                                                    <li>Enter type name (e.g., "Laptop", "Keyboard", "Monitor")</li>
                                                    <li>Add description and specifications</li>
                                                    <li>Click <strong>Save</strong></li>
                                                </ol>
                                                <div className="alert alert-success small">
                                                    <strong>Examples:</strong> Laptop, Desktop, Monitor, Keyboard, Mouse, Printer, Phone
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Vendors */}
                                    <div className="accordion-item">
                                        <h2 className="accordion-header">
                                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#vendors">
                                                <i className="fas fa-truck me-2"></i>
                                                Managing Vendors
                                            </button>
                                        </h2>
                                        <div id="vendors" className="accordion-collapse collapse" data-bs-parent="#helpAccordion">
                                            <div className="accordion-body">
                                                <h6>Adding Vendors:</h6>
                                                <ol>
                                                    <li>Navigate to <strong>Master Data → Vendors</strong></li>
                                                    <li>Click <span className="badge bg-primary">Add Vendor</span></li>
                                                    <li>Enter vendor name and contact details</li>
                                                    <li>Add address and phone number</li>
                                                    <li>Click <strong>Save</strong></li>
                                                </ol>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Employees */}
                                    <div className="accordion-item">
                                        <h2 className="accordion-header">
                                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#employees">
                                                <i className="fas fa-users me-2"></i>
                                                Managing Employees
                                            </button>
                                        </h2>
                                        <div id="employees" className="accordion-collapse collapse" data-bs-parent="#helpAccordion">
                                            <div className="accordion-body">
                                                <h6>Adding Employees:</h6>
                                                <ol>
                                                    <li>Go to <strong>Employees</strong> section</li>
                                                    <li>Click <span className="badge bg-success">Add Employee</span></li>
                                                    <li>Fill in employee details:
                                                        <ul>
                                                            <li>Full Name</li>
                                                            <li>Email Address</li>
                                                            <li>Select Department</li>
                                                            <li>Phone Number</li>
                                                        </ul>
                                                    </li>
                                                    <li>Click <strong>Save</strong></li>
                                                </ol>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Assets */}
                                    <div className="accordion-item">
                                        <h2 className="accordion-header">
                                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#assets">
                                                <i className="fas fa-laptop me-2"></i>
                                                Managing Assets
                                            </button>
                                        </h2>
                                        <div id="assets" className="accordion-collapse collapse" data-bs-parent="#helpAccordion">
                                            <div className="accordion-body">
                                                <h6>Adding Assets:</h6>
                                                <ol>
                                                    <li>Navigate to <strong>Assets</strong></li>
                                                    <li>Click <span className="badge bg-info">Add Asset</span></li>
                                                    <li>Fill in asset details:
                                                        <ul>
                                                            <li>Select Asset Type</li>
                                                            <li>Enter Serial Number (must be unique)</li>
                                                            <li>Model/Brand information</li>
                                                            <li>Purchase Date and Cost</li>
                                                            <li>Select Vendor</li>
                                                            <li>Set Status (usually "Available")</li>
                                                        </ul>
                                                    </li>
                                                    <li>Click <strong>Save</strong></li>
                                                </ol>
                                                <div className="alert alert-warning small">
                                                    <strong>Important:</strong> Serial numbers must be unique for each asset.
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Asset Assignments */}
                                    <div className="accordion-item">
                                        <h2 className="accordion-header">
                                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#assignments">
                                                <i className="fas fa-handshake me-2"></i>
                                                Asset Assignments
                                            </button>
                                        </h2>
                                        <div id="assignments" className="accordion-collapse collapse" data-bs-parent="#helpAccordion">
                                            <div className="accordion-body">
                                                <h6>Single Asset Assignment:</h6>
                                                <ol>
                                                    <li>Go to <strong>Asset Assignments</strong></li>
                                                    <li>Click <span className="badge bg-warning">Assign Asset</span></li>
                                                    <li>Select Employee from dropdown</li>
                                                    <li>Choose Available Asset</li>
                                                    <li>Set Assignment Date</li>
                                                    <li>Add notes if needed</li>
                                                    <li>Click <strong>Assign</strong></li>
                                                </ol>
                                                
                                                <h6 className="mt-3">Bulk Assignment:</h6>
                                                <ol>
                                                    <li>Select multiple assets using checkboxes</li>
                                                    <li>Click <span className="badge bg-primary">Bulk Assign</span></li>
                                                    <li>Choose the employee</li>
                                                    <li>Confirm bulk assignment</li>
                                                </ol>
                                                
                                                <h6 className="mt-3">Returning Assets:</h6>
                                                <ol>
                                                    <li>Find the assignment in the list</li>
                                                    <li>Click <span className="badge bg-danger">Return</span> button</li>
                                                    <li>Confirm the return</li>
                                                    <li>Asset status changes to "Available"</li>
                                                </ol>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Repairs */}
                                    <div className="accordion-item">
                                        <h2 className="accordion-header">
                                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#repairs">
                                                <i className="fas fa-wrench me-2"></i>
                                                Repair Management
                                            </button>
                                        </h2>
                                        <div id="repairs" className="accordion-collapse collapse" data-bs-parent="#helpAccordion">
                                            <div className="accordion-body">
                                                <h6>Logging Repairs:</h6>
                                                <ol>
                                                    <li>Go to <strong>Repairs</strong> section</li>
                                                    <li>Click <span className="badge bg-warning">Add Repair</span></li>
                                                    <li>Select the asset needing repair</li>
                                                    <li>Enter repair description</li>
                                                    <li>Set repair status (Pending, In Progress, Completed)</li>
                                                    <li>Enter repair cost</li>
                                                    <li>Add repair date</li>
                                                    <li>Click <strong>Save</strong></li>
                                                </ol>
                                                
                                                <h6 className="mt-3">Repair Status:</h6>
                                                <ul>
                                                    <li><span className="badge bg-warning">Pending</span> - Repair requested</li>
                                                    <li><span className="badge bg-info">In Progress</span> - Being repaired</li>
                                                    <li><span className="badge bg-success">Completed</span> - Repair finished</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Users & Permissions */}
                                    <div className="accordion-item">
                                        <h2 className="accordion-header">
                                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#users">
                                                <i className="fas fa-users-cog me-2"></i>
                                                User Management (Admin Only)
                                            </button>
                                        </h2>
                                        <div id="users" className="accordion-collapse collapse" data-bs-parent="#helpAccordion">
                                            <div className="accordion-body">
                                                <h6>Adding Users:</h6>
                                                <ol>
                                                    <li>Navigate to <strong>Users</strong> (Admin only)</li>
                                                    <li>Click <span className="badge bg-primary">Add User</span></li>
                                                    <li>Enter username and password</li>
                                                    <li>Select user role and permissions</li>
                                                    <li>Click <strong>Save</strong></li>
                                                </ol>
                                                
                                                <h6 className="mt-3">User Roles:</h6>
                                                <ul>
                                                    <li><strong>Admin:</strong> Full system access</li>
                                                    <li><strong>Manager:</strong> View and manage assets</li>
                                                    <li><strong>ReadOnly:</strong> View-only access with no add/edit/delete permissions</li>
                                                    <li><strong>User:</strong> View only access</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>

                                    {/* AI Search */}
                                    <div className="accordion-item">
                                        <h2 className="accordion-header">
                                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#aiSearch">
                                                <i className="fas fa-brain me-2"></i>
                                                AI Search (Admin Only)
                                            </button>
                                        </h2>
                                        <div id="aiSearch" className="accordion-collapse collapse" data-bs-parent="#helpAccordion">
                                            <div className="accordion-body">
                                                <h6>Using AI Search:</h6>
                                                <ol>
                                                    <li>Click <strong>AI Search</strong> in the navigation</li>
                                                    <li>Type natural language queries like:
                                                        <ul>
                                                            <li>"Show me all laptops in IT department"</li>
                                                            <li>"Find assets assigned to John Smith"</li>
                                                            <li>"List all available keyboards"</li>
                                                            <li>"Show repair costs for this month"</li>
                                                        </ul>
                                                    </li>
                                                    <li>View results in real-time</li>
                                                </ol>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>

                            {/* Quick Tips */}
                            <section className="mb-4">
                                <h5 className="text-primary mb-3">
                                    <i className="fas fa-lightbulb me-2"></i>
                                    Quick Tips
                                </h5>
                                <div className="row g-3">
                                    <div className="col-lg-4">
                                        <div className="tip-box bg-success">
                                            <h6><i className="fas fa-check me-1"></i>Best Practices</h6>
                                            <ul className="small">
                                                <li>Use unique serial numbers</li>
                                                <li>Keep employee data updated</li>
                                                <li>Process returns promptly</li>
                                                <li>Regular asset audits</li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="col-lg-4">
                                        <div className="tip-box bg-warning">
                                            <h6><i className="fas fa-exclamation-triangle me-1"></i>Avoid</h6>
                                            <ul className="small">
                                                <li>Duplicate serial numbers</li>
                                                <li>Skipping return process</li>
                                                <li>Deleting assigned assets</li>
                                                <li>Ignoring repair status</li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="col-lg-4">
                                        <div className="tip-box bg-info">
                                            <h6><i className="fas fa-star me-1"></i>Pro Tips</h6>
                                            <ul className="small">
                                                <li>Use filters for quick search</li>
                                                <li>Export data for reports</li>
                                                <li>Check dashboard regularly</li>
                                                <li>Use bulk operations</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </section>

                            {/* Support */}
                            <div className="help-support">
                                <h6>Need Additional Help?</h6>
                                <p className="mb-2">Contact your system administrator for technical support.</p>
                                <small className="text-muted">
                                    <i className="fas fa-info-circle me-1"></i>
                                    Saral Asset Management System v1.0
                                </small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Help;
